import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import ObjectDefinition from '../ObjectDefinition';
import {transferOrderJsonObject, transferOrderAttributes} from '../../data/transferOrders/transferOrderSchema';
import {transferOrdersHeader} from '../../data/transferOrders/transferOrder';
import RequestDefinition from '../RequestDefinition';

export default new RouteComponent(`${apiRoutePrefix}/transfer-orders`, () => {
    return (
        <div>
            <ObjectHeader data={ transferOrdersHeader }/>

            <ObjectDefinition data={ {
                title: 'The transfer order object',
                attributes: transferOrderAttributes,
                jsonObject: transferOrderJsonObject
            } }/>

            {
                transferOrdersHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
